// Turns raw stock numbers into one quiet line of copy. Every line counts what is still available,
// and it stays neutral while there is plenty, turning specific (and brand red) once it matters.
export function stockNote({ quantity, remaining }) {
  if (remaining <= 0) return { tone: 'out', text: 'Udsolgt' }
  if (remaining === 1) return { tone: 'low', text: 'Sidste stk.' }
  if (remaining <= 3 || remaining / quantity <= 0.2) return { tone: 'low', text: `Kun ${remaining} tilbage` }
  if (remaining / quantity <= 0.5) return { tone: 'mid', text: `${remaining} af ${quantity} tilbage` }
  return { tone: 'fresh', text: `${remaining} stk. tilbage` }
}
